import { Icon, Space, SubText, Text, WithPopover } from '@procurify/ui'

import { BillItemExceptionUnitCostVarianceContent } from '@webapp/components/BillItemPopover'
import { Price } from '@webapp/core/components/Price'
import { useFormatPrice, useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { type ColumnTypeData } from '../../types/DataTable.types'

// Remove this when AP_10171_AP_INLINE_EDITS is removed
export const APItemUnitCostCell = ({
  billByCost,
  currencyName,
  exception,
  unitCost,
}: ColumnTypeData['AP_ITEM_UNIT_COST']) => {
  const intl = useProcurifyIntl()

  const hasException = !!exception

  const formatPrice = useFormatPrice({ mdp: true, useSystemLocale: false })

  return billByCost ? (
    <Space>
      <Text>{'--'}</Text>
    </Space>
  ) : (
    <WithPopover
      content={
        <BillItemExceptionUnitCostVarianceContent exception={exception} />
      }
      disableHoverListener={!hasException}
      placement='top'
    >
      <Space direction='horizontal' align='center' justify='end' size='xsmall'>
        {hasException && (
          <Space.Item>
            <Icon
              icon={exception.isOverBilled ? 'close' : 'attention'}
              color={exception.isOverBilled ? 'error' : 'warning'}
              size={16}
              aria-label={intl.formatMessage(messages.iconAriaLabel)}
            />
          </Space.Item>
        )}

        <Space.Item>
          <Space direction='vertical' size='xsmall'>
            <Space.Item>
              <Price
                price={unitCost}
                currency={currencyName}
                fontWeight={exception?.isOverBilled ? 'bold' : 'normal'}
              />
            </Space.Item>
            {hasException && (
              <Space.Item>
                <SubText inline color={exception.isOverBilled && 'error'}>
                  {` ${exception.isOverBilled ? '+' : ''}${formatPrice(exception.variance)}`}
                </SubText>
              </Space.Item>
            )}
          </Space>
        </Space.Item>
      </Space>
    </WithPopover>
  )
}
